import type {
  VFloor,
  VRoom,
  VScene,
  VTour,
  MapPosition2D,
  RoomMeasures,
} from "@/types";
import { createContext } from "use-context-selector";

export interface PendingScene {
  id: string;
  name: string;
  room_id: string | null;
  floor_id: string | null;
  tour_id: string | null;
  progress: number; // 0-100
}

export interface TourDataValue {
  tour: VTour | null;
  allScenes: VScene[];
  allRooms: VRoom[];
  allFloors: VFloor[];
  isOwner: boolean;
  canEdit: boolean;
  exitPath: string;
  refresh: (sceneId?: string) => Promise<void>;
  updateRoomMapPosLocal: (roomId: string, pos: MapPosition2D | null) => void;
  updateRoomShapeLocal: (
    roomId: string,
    shape: MapPosition2D[] | null,
    measures?: RoomMeasures,
  ) => void;
  /** Local mirror of `rooms.shape_hidden` (polygon on/off the plan). */
  updateRoomShapeHiddenLocal: (roomId: string, hidden: boolean) => void;
  updateSceneLocal: (sceneId: string, updates: Partial<VScene>) => void;
  updateRoomLocal: (roomId: string, updates: Partial<VRoom>) => void;
  updateFloorLocal: (floorId: string, updates: Partial<VFloor>) => void;
  addFloorLocal: (floor: VFloor) => void;
  addSceneLocal: (scene: VScene) => void;
  addRoomLocal: (room: VRoom) => void;
  removeSceneLocal: (sceneId: string) => void;
  removeRoomLocal: (roomId: string) => void;
  removeFloorLocal: (floorId: string) => void;
  pendingScenes: PendingScene[];
  addPendingScene: (scene: PendingScene) => void;
  removePendingScene: (id: string) => void;
  updatePendingSceneProgress: (id: string, progress: number) => void;
  updateTourLocal: (updates: Partial<VTour>) => void;
}

export interface TourSceneValue {
  currentScene: VScene | null;
  loadingScene: boolean;
  selectScene: (sceneId: string) => void;
  clearScene: () => void;
}

export const TourDataContext = createContext<TourDataValue | null>(null);
export const TourSceneContext = createContext<TourSceneValue | null>(null);
